/**
 * @generated SignedSource<<48fbac423076af9128015285e0a1dd05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentSuggestedPromptsListContentFragment$data = {
  readonly brainSearchRelatedQuestions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentSuggestedPromptListItemQuestion">;
      };
    }>;
  };
  readonly hasProcessedMediaAssets: boolean;
  readonly hasUnprocessedMediaAssets: boolean;
  readonly id: string;
  readonly richEditorDescriptionContent: string | null;
  readonly " $fragmentType": "ContentSuggestedPromptsListContentFragment";
};
export type ContentSuggestedPromptsListContentFragment$key = {
  readonly " $data"?: ContentSuggestedPromptsListContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentSuggestedPromptsListContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./ContentSuggestedPromptsListRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ContentSuggestedPromptsListContentFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "richEditorDescriptionContent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasUnprocessedMediaAssets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasProcessedMediaAssets",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 3
        }
      ],
      "concreteType": "BrainSearchRelatedQuestionNodeConnection",
      "kind": "LinkedField",
      "name": "brainSearchRelatedQuestions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BrainSearchRelatedQuestionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BrainSearchRelatedQuestion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ContentSuggestedPromptListItemQuestion"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "brainSearchRelatedQuestions(last:3)"
    }
  ],
  "type": "Content",
  "abstractKey": null
};
})();

(node as any).hash = "4dcb9ea585c9e32a1963babb523995e6";

export default node;
